import React, { useEffect, useState } from "react";
import Select from "react-select";
import { getApi } from "../../../services/api/globalApi";
import { useSelector } from "react-redux";
import { utilsState } from "../../../sotre/redux/features/utilsSlice";

const { forwardRef, useRef, useImperativeHandle } = React;

const SliderTageSelect = forwardRef(
  ({ oldSliderTags, onChange, label }, ref) => {
    const [sliderTags, setSliderTags] = useState([]);
    const [sliderTagsOption, setSliderTagsOption] = useState([]);
    const [selectedSliderTags, setSelectedSliderTas] = useState([]);

    useImperativeHandle(ref, () => ({
      afterSubmit() {
        setSelectedSliderTas([]);
      },
    }));

    const { utils } = useSelector(utilsState);

    useEffect(() => {
      if (utils?.SLIDERS_TAGS_VALUES?.length) {
        setSliderTags(utils.SLIDERS_TAGS_VALUES.filter((item) => item.value !== "DONE_AKHARI"));
      }
    }, [utils]);

    useEffect(() => {
      console.log(sliderTags);
      let newCategory = [];

      // sliderTagsOption.length <= 0 &&
      sliderTags?.map((item) =>
        newCategory.push({
          value: item.value,
          label: item.name,
        })
      );
      setSliderTagsOption(newCategory);
    }, [sliderTags]);

    function handleSliderTags(data) {
      setSelectedSliderTas(data);
      const newData = data.map((item) => {
        return item.value;
      });
      onChange(newData || []);
    }

    useEffect(() => {
      console.log(oldSliderTags);
      if (oldSliderTags?.length > 0) {
        let selectedSliderTags = [];
        for (let i = 0; i < oldSliderTags?.length; i++) {
          if (oldSliderTags[i] === "DONE_AKHARI") continue;
          let isExist = sliderTags.filter((item) => {
            return item.value == oldSliderTags[i];
          });
          selectedSliderTags.push({
            value: isExist[0]?.value,
            label: isExist[0]?.name,
          });
          console.log(isExist);
        }
        console.log(selectedSliderTags);
        setSelectedSliderTas(selectedSliderTags);
      }
    }, [oldSliderTags, sliderTags]);

    console.log(selectedSliderTags);

    return (
      <div>
        {label ? (
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            {label}
          </label>
        ) : null}
        <Select
        classNamePrefix="admin-select"
        isRtl
          className=""
          options={sliderTagsOption}
          placeholder="انتخاب تگ اسلایدر"
          value={selectedSliderTags}
          onChange={handleSliderTags}
          isSearchable={true}
          isMulti
        />
      </div>
    );
  }
);

export default SliderTageSelect;
